import { gql } from '@apollo/client';

export const GET_EVM_NFTS_BY_OWNERS = gql`
  query GetEvmNFTsByOwners($data: GetEvmNFTsByOwnersInput!) {
    getEvmNFTsByOwners(data: $data) {
      tokenId
      tokenType
      name
      description
      tokenUri
      image {
        cachedUrl
        thumbnailUrl
        pngUrl
        contentType
        size
        originalUrl
      }
      metadata {
        name
        image
        description
        animation_url
        attributes {
          value
          trait_type
          max_value
        }
      }
      structuredAttributes
      owner
      balance
      contract {
        address
        name
      }
      acquiredAt {
        blockTimestamp
        blockNumber
      }
      equippedWearables {
        avatarId
        templateId
        tokenId
      }
    }
  }
`;
